import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'raggColumnBackground'})
export class RaggColumnBackground implements PipeTransform {
  transform(value: number, dictionary: []) {
    const word: any = dictionary.find((element: any) => element.id == value);
    return word ? word.colorHash : '#fff';
  }
}
